import Typography from '@mui/material/Typography'
import type { ReactNode } from 'react'

type Props = Readonly<{
  children: ReactNode
  testId?: string
}>

export function ListPageCountBadge({ children, testId }: Props) {
  return (
    <Typography
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        height: '26px',
        px: '10px',
        borderRadius: '100px',
        border: '1px solid #3285d7',
        bgcolor: '#e3f2fd',
        color: '#1976d2',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
      }}
      data-testid={testId}
    >
      {children}
    </Typography>
  )
}
